import genericContentItemAnswer from '@shared/components/mixins/genericContentItemAnswer'
import pxToEm from '@shared/components/mixins/shared/pxToEm'

export default {
  name: 'FieldComponent',
  mixins: [genericContentItemAnswer, pxToEm],
  props: {
    component: {
      type: Object,
      required: true,
    },
    validation: {
      type: Object,
      required: false,
    },
  },
  computed: {
    fieldPlaceHolder() {
      const mandatoryText =
        this.component.content.placeholder.length > 0
          ? this.component.content.placeholder + '*'
          : ''
      return this.component.settings.required ? mandatoryText : this.component.content.placeholder
    },
  },
  methods: {
    triggerInputChange() {
      this.$eventBus.$emit('field-answer', this.answer)
    },
  },
}
